import { I18n } from '@editorjs/editorjs/types/api';

export default abstract class DomFactory {
  public readonly i18n: I18n;
  constructor(i18n: I18n) {
    this.i18n = i18n;
  }
  abstract createWrapper(): HTMLElement;
}
